<template>
  <div class="frontpage-search">
    <div class="frontpage-search__wrapper">
      <div
        class="search-component"
        :class="{ 'search-component--price-overview': currentTab == 1 }"
      >
        <slot></slot>
        <div class="search-component__wrapper">
          <div class="search-component__wrapper__block">
            <div class="search-component__nav">
              <button
                v-for="(tab, tIndex) in tabs"
                :key="tIndex"
                :class="{ current: currentTab == tIndex }"
                @click="() => (currentTab = tIndex)"
                v-text="tab"
              ></button>
            </div>
            <search-fields v-show="currentTab == 0"></search-fields>
            <price-overview-fields v-show="currentTab == 1"></price-overview-fields>
          </div>
        </div>
        <div class="search-component__logos">
          <div class="search-component__logos__grid">
            <figure>
              <img src="./../../../img/logos/logo-white-alltours.svg" alt="" class="logo-alltours"/>
            </figure>
            <figure>
              <img src="./../../../img/logos/logo-white-tui.svg" alt="" class="logo-tui" />
            </figure>
            <figure>
               <img src="./../../../img/logos/logo-white-der-touristik.svg" alt="" class="logo-der" />
            </figure>
          </div>
          <span
            class="search-component__logos__end-text"
            v-text="translations.logo_text_last"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import SearchFields from "./partials/search-fields.vue";
import { trackEvent } from "../../tracker";
import PriceOverviewFields from './partials/price-overview-fields.vue';

export default {
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.FRONTPAGE_SEARCH,
      currentTab: 0,
      tabs: APP_CONFIG.TRANSLATION.FRONTPAGE_SEARCH.tabs,
    };
  },
  watch: {
    currentTab() {
      if (this.currentTab == 1) {
        trackEvent({
          event: "Klik på prisoversigt",
          destination: "Prisoversigtsiden",
          "interaction-type": "noninteraction",
        });
      }
    },
  },
  components: {
    SearchFields,
    PriceOverviewFields,
  },
};
</script>